export function maskMobileNumber(phone: string): string {
    // Keep only digits
    const digits = phone.replace(/\D/g, '');
  
    // Normalize to 989xxxxxxxxx
    let normalized = digits;
  
    if (normalized.startsWith('0098')) {
      normalized = normalized.slice(2);
    } else if (normalized.startsWith('0')) {
      normalized = '98' + normalized.slice(1);
    }
  
    // Must be 98 + 10 digits
    if (!/^98\d{10}$/.test(normalized)) {
      return phone;
    }
  
    return `+98 ${normalized.slice(2, 5)} ••• ••••`;
  }